import { cn } from "utils";
import {
  SCORE_COLORS,
  SCORE_COLOR_ZERO_CARD_VIEW,
} from "constants/scoreColors";

const VARIANT_CLASSNAMES = {
  default: "rounded-md",
  avatarOverlay: "rounded-tl-none rounded-tr-md rounded-br-md rounded-bl-md",
};

const MatchScoreBadge = ({
  ideal,
  score,
  showLabel = true,
  label = "Match Score: ",
  variant = "default",
  className,
}) => {
  if (score === undefined) {
    return null;
  }

  const text = ideal
    ? "Ideal Candidate"
    : `${showLabel ? label : ""}${score}/5`;

  // Use black for score 0 in card views
  let backgroundColor;
  if (ideal) {
    backgroundColor = SCORE_COLORS.ideal;
  } else if (score === 0) {
    backgroundColor = SCORE_COLOR_ZERO_CARD_VIEW;
  } else {
    backgroundColor = SCORE_COLORS[score];
  }

  return (
    <span
      className={cn(
        "inline-flex h-7 items-center px-3 text-sm font-semibold text-white",
        VARIANT_CLASSNAMES[variant],
        className
      )}
      style={{ backgroundColor }}
    >
      {text}
    </span>
  );
};

export default MatchScoreBadge;
